import { MethodEvaluationEnum } from './enums';
import { PliValueType } from './pli-value-type';

export class MethodEvaluation {
  pbaMethodEvaluationId?: number;
  tbaMethodEvaluationId?: number;
  transactionId?: number;
  srcDiscussion: string;
  destDiscussion: string;
  sourceEvaluationType?: MethodEvaluationEnum;
  destinationEvaluationType?: MethodEvaluationEnum;
  compSearchId?: number;
  pliValueType?: PliValueType;
}
